//Signup
export const PROVIDER_REGISTER_DETAILS = null;
// otp
export const PROVIDER_VERIFY_PHONE = null;
export const PROVIDER_VERIFY_EMAIL = null;
// password
export const PROVIDER_SET_NEW_PASSWORD = null;
// profile-setup
export const PROVIDER_SET_UP_PROFILE = null;
export const PROVIDER_SET_UP_PROFILE_BANK_ACCOUNT = null;
// provider location
export const PROVIDER_COUNTRY = null;
export const PROVIDER_STATE = null;
export const PROVIDER_CITY = null;
//login
export const PROVIDER_LOGIN = null;
export const PROVIDER_FORGOT_PASSWORD = null;
export const PROVIDER_FORGOT_PASSWORD_VERIFICATION = null;
export const PROVIDER_RESET_PASSWORD = null;
// resend-otp
export const PROVIDER_RESEND_OTP_PHONE = null;
export const PROVIDER_RESEND_OTP_EMAIL = null;
// cleanup -> state and city
export const CLEANUP_State_LIST = null;
export const CLEANUP_CITY_LIST = null;
// provide-profile-image
export const PROVIDER_PROFILE_IMAGE = null;
export const PROVIDER_LOGOUT = null;

export const UPDATE_PROVIDER_PROFILE = null;

export const USER_CONVERSION_DIALOG_OPEN = null;
export const USER_CONVERSION_DIALOG_FALSE = null;
export const SAVE_FCM = null;
